import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { gpuAdminConfigured, gpuClient, unwrapGpu } from '@/api/gpu/client'

import { GPU_KEY } from './useGpuAdmin'
import type { PageQuery } from './useGpuOperations'

export function useAkashBlockHistory(page: PageQuery) {
  return useQuery({
    queryKey: [...GPU_KEY, 'akash-block-history', page],
    enabled: gpuAdminConfigured,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      unwrapGpu(
        await gpuClient.GET('/gpu/admin/v1/akash/provider-blocks/history', {
          params: { query: page },
        }),
        'Failed to load Akash block history',
      ),
  })
}
